"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IntroductionToOurPrivacyPolicy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section className="relative w-full min-h-[60vh] flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(/img/clinic_hallway_softfocus.png)]" style={{
      filter: "blur(1px)"
    }} />
      <div className="absolute inset-0 bg-primary/10" />

      {}
      <div ref={ref} className="container relative z-10 max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-16 text-center">
        {}
        <h1 className={`font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground mb-6 transition-all duration-300 ease-out-back ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          Introduction to Our Privacy Policy
        </h1>

        {}
        <p className={`text-lg sm:text-xl text-muted-dark leading-relaxed mb-10 transition-all duration-300 ease-out-back delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          We are committed to protecting your privacy and ensuring the security
          of your personal information. This policy outlines how we collect,
          use, and safeguard your data with the utmost care and transparency.
        </p>

        {}
        <div className={`transition-all duration-300 ease-out-back delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <Link to="#privacy-details">
            
          </Link>
        </div>
      </div>
    </section>;
}